export const SYSTEM_TYPES = [
  {value: 'Compliance', display: 'Compliance'},
  {value: 'Learning Platform', display: 'Learning Platform'},
  {value: 'LMS', display: 'LMS'},
  {value: 'LMS/LXP', display: 'LMS/LXP'},
  {value: 'Talent Development', display: 'Talent Development'},
  {value: 'Workforce Development', display: 'Workforce Development'},
]
